import arriereBackoffice, {
  NotificationType,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { Alert } from '@avantstay/backoffice-core'

// Notification types not rendered by the voyage UI (no title/body mapping).
// They are produced by the operations backend for the Fresh app (vendorapp) and
// for HK Managers, and rendering them here would show empty cards. Filtered out
// at the service layer so they don't affect the unread badge or counts either.
const UNSUPPORTED_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.nonClosedInspections,
  NotificationType.nonClosedHotelInspections,
]

const isSupportedNotificationType = (type: NotificationType): boolean =>
  !UNSUPPORTED_NOTIFICATION_TYPES.includes(type)

export const getNotifications = async () => {
  return arriereBackoffice.queries
    .notifications({
      __alias: 'notifications_getNotifications',
      notifications: {
        __args: {
          withCasesAssignedToMeOnly: false,
          unreadOnly: false,
        },
        id: true,
        notificationType: true,
        customLocalDate: true,
        createdAt: true,
        readAt: true,
        caseSubject: true,
        casePriority: true,
        workOrderId: true,
        homeName: true,
        commentAuthorName: true,
      },
    })
    .then(results => {
      return results.notifications.filter(notification =>
        isSupportedNotificationType(notification.notificationType),
      )
    })
    .catch(error => {
      Alert.Error((error as Error).message)
      return []
    })
}

export const readNotifications = async (notificationIds: string[]) => {
  return arriereBackoffice.mutations
    .notifications({
      __alias: 'notifications_readNotification',
      markNotificationsAsRead: {
        __args: { notificationIds },
      },
    })
    .catch(error => {
      Alert.Error((error as Error).message)
    })
}
